export default {
  COMMENTS_MODAL: {
    TITLE: `Comments`,
    SUMMARY: ``
  },
  COMMENTS: {
    TITLE: `Comments`,
    SUMMARY: ``
  },
  DELETE_BUTTON: {
    TITLE: `Delete the comment`,
    SUMMARY: `Are you sure you want to delete this comment?`,
    PRIMARY_ACTION: `Delete the comment`
  },
  PUNCHIN_COMMENT: `Punch-in comment`,
  TRANSFER_COMMENTS: `Transfer comments`,
  PUNCHOUT_COMMENT: `Punch-out comment`,
  EDIT_HISTORY: `Edit history`,
  NO_COMMENTS: `No comments`,
  COMMENT_UPDATED_SUCCESSFULLY: `Comment updated successfully`,
  COMMENT_NOT_UPDATED_SUCCESSFULLY: `Comment could not be updated, please try again.`,
  COMMENT_ADDED_SUCCESSFULLY: `Comment added successfully`,
  COMMENT_NOT_ADDED_SUCCESSFULLY: `Comment could not be added, please try again`,
  COMMENT_DELETED_SUCCESSFULLY: `Comment deleted successfully`,
  COMMENT_NOT_DELETED_SUCCESSFULLY: `Comment could not be deleted, please try again.`,
  SHOW_EDITS: `Show edits`,
  ADDED_NEW_COMMENT: `comment added`,
  UPDATED_COMMENT: `comment updated`,
  INPUT_COMMENT_PLACEHOLDER: `Write a comment...`,
  DELETE_CONFIRMATION: `Delete this comment?`,
  MODAL_CONTENT_LABEL: `Comments history modal`,
  QUIT_PAGE: `Your changes have not been saved. Are you sure you want to leave?`
}
